var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 1L5 5L1 1","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronDown.defaultProps = {"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
